export const environment = {
    name: 'DEVELOPMENT ENV',
    production: false,
    host: 'https://dev.masarat-insurance.com',
    iamHost: 'https://kc.dev.masarat-insurance.com',
    apiBaseUrl: 'https://dev.masarat-insurance.com/api/v1',
}